import { UserAPI } from "@ai360/core";

/**
 * The user whose company is the login's last-used company. All `theUsers` carry the
 * same login-level `lastUsedCompanyGuid` (the last-used company's orgLevelGuid), so
 * `theUsers[0]` is authoritative. Returns null if there are no users, no last-used
 * value, or the last-used company isn't among `theUsers` (e.g. it lives in another
 * Agvance DB — Task 11's redirect handles the connected cross-DB case).
 */
export const getLastUsedUser = (
    theUsers: UserAPI.IUser[] | null | undefined
): UserAPI.IUser | null => {
    if (!theUsers || theUsers.length === 0) {
        return null;
    }
    const lastUsedCompanyGuid = theUsers[0].lastUsedCompanyGuid;
    if (!lastUsedCompanyGuid) {
        return null;
    }
    return theUsers.find((u) => u.companyGuid === lastUsedCompanyGuid) || null;
};
